import { T } from '@tribeplatform/react-components/i18n'

import { OtherSettings } from '../OtherSettings.js'

export function CommunityOtherSettingsRouter() {
  return <OtherSettings />
}

export function CommunityOtherSettingsBreadCrumb() {
  return <T id="Settings.Other" defaultMessage="Other" />
}
